export enum Layout {
    Horizontal = 'horizontal-layout',
    OverlaySidebar = 'overlay-sidebar-layout',
  }
  
  export enum LayoutMenuTheme {
    Primary = 'primary-color-theme',
    Surface = 'surface-color-theme',
    Transparent = 'transparent-color-theme',
    Gray = 'gray-color-theme',
  }
  
  export enum LayoutTheme {
    Light = 'aura-light-blue',
    Dark = 'aura-dark-noir',
    BigSky = 'workforce-management',
  }
  
  export enum LayoutBaseFontSize {
    ExtraSmall = '12px',
    Small = '13px',
    Normal = '14px',
    Large = '15px',
    ExtraLarge = '16px',
  }
  